import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { HiX, HiPlus, HiOutlineUser, HiOutlineLockClosed, HiOutlineShieldCheck } from "react-icons/hi";
import "../styles.css";

function ModalCrearUsuario({ visible, onClose, onGuardar }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rol, setRol] = useState("user");
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [exito, setExito] = useState(null);

  useEffect(() => {
    if (visible) {
      setUsername("");
      setPassword("");
      setRol("user");
      setError(null);
      setExito(null);
      setCargando(false);
    }
  }, [visible]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setExito(null);
    setCargando(true);

    try {
      if (onGuardar) {
        await onGuardar(username, password, rol);
        setExito(`Usuario '${username}' creado correctamente`);
        setTimeout(() => {
          onClose();
        }, 1500);
      }
    } catch (err) {
      setError(err.message || "Error creando usuario");
    } finally {
      setCargando(false);
    }
  };

  if (!visible) return null;

  const modalContent = (
    <div className="modal-overlay">
      <div className="modal animate-fadeIn" style={{ maxWidth: '450px' }}>
        <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <h2 style={{ margin: 0 }}>Crear Usuario</h2>
          <button className="btn-icon" onClick={onClose} style={{ background: 'transparent', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer' }}>
            <HiX size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="form-moderno">
          <div className="form-group" style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.85rem', fontWeight: 600 }}>Nombre de usuario</label>
            <div className="input-group-modern" style={{ position: 'relative' }}>
              <HiOutlineUser style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-secondary)' }} />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="Ej. juan.perez"
                style={{ width: '100%', padding: '12px 12px 12px 40px', background: 'var(--bg-main)', border: '1px solid var(--glass-border)', borderRadius: 'var(--radius-md)', color: 'var(--text-primary)' }}
              />
            </div>
          </div>

          <div className="form-group" style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.85rem', fontWeight: 600 }}>Contraseña</label>
            <div className="input-group-modern" style={{ position: 'relative' }}>
              <HiOutlineLockClosed style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-secondary)' }} />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                style={{ width: '100%', padding: '12px 12px 12px 40px', background: 'var(--bg-main)', border: '1px solid var(--glass-border)', borderRadius: 'var(--radius-md)', color: 'var(--text-primary)' }}
              />
            </div>
          </div>

          <div className="form-group" style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.85rem', fontWeight: 600 }}>Rol de usuario</label>
            <div className="input-group-modern" style={{ position: 'relative' }}>
              <HiOutlineShieldCheck style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-secondary)' }} />
              <select
                value={rol}
                onChange={(e) => setRol(e.target.value)}
                style={{ width: '100%', padding: '12px 12px 12px 40px', background: 'var(--bg-main)', border: '1px solid var(--glass-border)', borderRadius: 'var(--radius-md)', color: 'var(--text-primary)' }}
              >
                <option value="user">Usuario Estándar</option>
                <option value="admin">Administrador</option>
              </select>
            </div>
          </div>

          {error && <div className="login-error" style={{ marginBottom: '20px' }}>{error}</div>}
          {exito && <div style={{ background: 'rgba(16, 185, 129, 0.1)', color: 'var(--accent-success)', padding: '12px', borderRadius: 'var(--radius-md)', fontSize: '0.85rem', textAlign: 'center', border: '1px solid rgba(16, 185, 129, 0.2)', marginBottom: '20px' }}>{exito}</div>}

          <div className="modal-footer" style={{ marginTop: '32px', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
            <button
              type="button"
              className="btn-gestion"
              onClick={onClose}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn-nueva"
              disabled={cargando}
              style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              {cargando ? "Creando..." : <><HiPlus /> Crear Usuario</>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}

export default ModalCrearUsuario;
